<h2 mat-dialog-title>{{ data.title || 'Choose your photo' }}</h2>
<mat-dialog-content>
  <p class="hint">Drag to move, and zoom until the circle shows what you want.</p>
  <div class="window" [style.width.px]="box" [style.height.px]="box"
    (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp()" (pointercancel)="onPointerUp()" (pointerleave)="onPointerUp()">
    <img #picture [src]="src" [style.transform]="transform" alt="" draggable="false" (load)="onZoom(zoom)" />
    <div class="mask"></div>
  </div>
  <div class="zoom">
    <mat-icon>zoom_out</mat-icon>
    <mat-slider [min]="minZoom" [max]="maxZoom" step="0.05" discrete="false">
      <input matSliderThumb [value]="zoom" (valueChange)="onZoom($event)" aria-label="Zoom" />
    </mat-slider>
    <mat-icon>zoom_in</mat-icon>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="saving">Use this photo</button>
</mat-dialog-actions>
